<template>
    <BreadCrumb PageTitle="Liste des auteurs" />
    <ListeAuteur />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeAuteur from "../../components/Auteur/ListeActeur.vue";

    export default defineComponent({
        name: "ListeAuteurPage",
        components: {
            BreadCrumb,
            ListeAuteur,
        },
    });
</script>